"use client";

import BFLButton from "@repo/shared-ui/BFLButton";
import React, { FC } from "react";

interface FilterButtonProps {
  label: string;
  selectedCount?: number;
  isOpen?: boolean;
  onClick: () => void;
}

const FilterChevronIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="block shrink-0"
  >
    <path
      d="M1.75 4.25L5.5 7.75L9.25 4.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FilterButton: FC<FilterButtonProps> = ({
  label,
  selectedCount = 0,
  isOpen = false,
  onClick,
}) => {
  return (
    <div className="relative shrink-0 border-l border-[rgba(0,0,0,0.12)]">
      <BFLButton
        type="button"
        onClick={onClick}
        className="box-border flex h-full w-[100px] items-center gap-1 p-4 text-[12px] font-medium md:text-sm text-link-primary"
        aria-haspopup="dialog"
        aria-expanded={isOpen}
      >
        <span>{label}</span>
        <span className="inline-flex items-center gap-1">
          {selectedCount > 0 && (
            <span
              aria-hidden="true"
              className="box-border flex h-[15px] w-[15px] shrink-0 items-center justify-center rounded-full border border-[#d2d2d2] bg-link-primary p-0 text-white"
            >
              <span className="flex w-full items-center justify-center text-[10px] font-medium leading-[10px] tabular-nums">
                {selectedCount}
              </span>
            </span>
          )}
          <span
            className="flex size-[11px] shrink-0 items-center justify-center text-link-primary"
            aria-hidden="true"
          >
            <FilterChevronIcon />
          </span>
        </span>
      </BFLButton>
    </div>
  );
};

export default FilterButton;
